// extracted by mini-css-extract-plugin
export default {"feedbackOptions":"FeedbackOptions_feedbackOptions__y5v0f","button":"FeedbackOptions_button__eOoGc"};